import { Type } from 'class-transformer';
import {ValueListItem} from "../../core/_datamodel/common";

export class KBRequest {
  kb_requests_id: number | undefined;
  // @ts-ignore
  @Type(() => Date)
  c_date: Date | undefined;
  status: KBRequestStatus | undefined;
  c_user_id: number | undefined;
  request_data: string | undefined;
  request_title: string | undefined;
  language: string | undefined;
  id_repository: number | undefined;

  get idDisplay() {
    return `#${this.kb_requests_id}`;
  }

  get statusDisplay() {
    switch (this.status) {
      case KBRequestStatus.Open: return 'Open';
      case KBRequestStatus.Accepted: return 'Accepted';
      case KBRequestStatus.Rejected: return 'Rejected';
      default: return '';
    }
  }

  get statusSeverity(): any {
    return getKBRequestStatusSeverity(this.status);
  }
}

export enum KBRequestStatus {
  Open = 0,
  Accepted = 1,
  Rejected = 2
}

export function getKBRequestStatusSeverity(status: KBRequestStatus | undefined): any {
  switch (status) {
    case KBRequestStatus.Open: return 'info';
    case KBRequestStatus.Accepted: return 'success';
    case KBRequestStatus.Rejected: return 'danger';
    default: return 'contrast';
  }
}

export const KB_REQUEST_STATUS_VALUELIST: ValueListItem[] = [
  { label: 'Open', value: KBRequestStatus.Open },
  { label: 'Accepted', value: KBRequestStatus.Accepted },
  { label: 'Rejected', value: KBRequestStatus.Rejected },
]

export const KB_REQUEST_LANGUAGES = ['en','it'];
